<template>
  <van-popup v-model="openModal" @click-overlay="maskClicked">
    <div class="m-pop">
      <div class="m-pop-box">
        <div class="m-pop-cont">
          <h4 class="m-pop-title">风险免责说明</h4>
          <div class="m-pop-fixation">
            <div>
              &nbsp;&nbsp;&nbsp;&nbsp;{{disclaimer}}
            </div>
            <div class="notarizeState">
              <div class="notarize" @click="notarizeState = !notarizeState"><i class="icon" :class="{'active icon-radiochecked-copy': notarizeState ,'icon icon-danxuankuang': !notarizeState }"
              ></i>我已详细阅读以上风险免责说明，自愿要求删除这些体检项目，漏检风险自行承担。
              </div>
            </div>
            <div class="closeBtn">
              <button class="btn" @click="close">关闭说明</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  data () {
    return {
      notarizeState: this.recordCode
    }
  },
  props: {
    disclaimer: {
      type: String,
      default: ''
    },
    showModal: {
      type: Boolean,
      default: false
    },
    recordCode: {
      type: Boolean,
      default: false
    },
    showTxt: {
      type: String,
      default: ''
    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },
  watch: {
    recordCode (newV, oldV) {
      this.notarizeState = newV
    }
  },
  methods: {
    close (index) {
      this.$emit('btnClose', this.notarizeState)
    },
    maskClicked (e) {
      this.$emit('btnClick', 'mask')
    },
    lookExplain (e) {
      this.$emit('lookExplain')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .van-popup /deep/ {
    /*top: 45%;*/
    height: 85%;
    border-radius: 8px;
    padding-bottom: 10px;
    overflow: hidden;
    width: 90%;
    background: transparent !important;
  }

  .m-pop {
    background: transparent;
    top: 0;
    height: 100%;
    width: 100%;
    .m-pop-box {
      height: 100%;
      border-radius: 15px;
      padding-bottom: 20px;
      background-color: #ffffff;
      .m-project-list {
        padding-top: 8px;
        font-size: 16px;
        text-align: left;
        padding-left: 15px;
      }
      .m-pop-fixation {
        height: 100%;
        overflow-y: auto;
        padding: 13px 15px 25px 15px;
        border-bottom: 1px solid $darkEEE;
        .notarizeState {
          font-size: 23px;
          padding: 10px 0 20px 0;

          line-height: 25px;
          i {
            font-size: 25px;
            position: relative;
            top: 3px;
          }
          .active {
            color: $assertive;
          }
        }
        div {
          padding-left: 10px;
          text-align: left;
          font-size: 16px;
          width: 100%;
        }
      }
      .m-pop-cont {
        position: relative;
        width: 100%;
        padding: 20px 0px;
        overflow: hidden;
        height: 100%;
        text-align: center;
        h4 {
          font-weight: bold;
          line-height: 44px;
          font-size: 18px;
          color: #333333;
        }
        p {
          line-height: 24px;
          font-size: 14px;
          color: #666666;
        }
        .m-pop-title {
          line-height: 44px;
          font-size: 24px;
          font-weight: bold;
          color: $assertive;
        }
      }
      .closeBtn{
        text-align: center !important;
        padding-left: 0px !important;
      }
      .btn {
        height: 30px;
        margin: 0 auto;
        display: inline-block;
        line-height: 28px;
        padding: 0 24px;
        font-size: 14px;
        border-radius: 8px;
        margin-left: 10px;
        background-color: #ffffff;
        border: 1px solid rgb(242, 89, 48);
        color: rgb(242, 89, 48);

      }
    }
  }

</style>
